import React, {useContext} from 'react';
import {ARMcontext} from '../../utils/context/context';
import {FluidContainer} from '../';
import {Left} from '../../assets/icons/icons';
import {TabContainer, TabSpan, TabWrapper} from './styles';
import Media from '../Media/Media';
import { useLocation, useNavigate } from 'react-router-dom';
import { isAppInternalPath } from '../../utils/helpers/path';

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {RemoveSelectedPlayer, selectedPlayer, selectedTeam} = useContext(ARMcontext);

  function goBack() {
    if (selectedPlayer?.name) {
      const exitTo = (location.state as { exitTo?: string } | null)?.exitTo;
      RemoveSelectedPlayer();
      if (exitTo && isAppInternalPath(exitTo)) {
        navigate(exitTo, { replace: true });
      }
    } else {
      navigate('/teams/card');
    }
  }

  return (
    <TabContainer>
      <FluidContainer>
        <TabWrapper onClick={goBack} data-cy="previus-tab">
          <Left height="14px" hColor="var(--ContrastGray)" />
          {selectedPlayer?.name ? (
            <>
              <TabSpan>{selectedTeam.name + ' / '}</TabSpan>
              <Media fontSize={'14px'} size={'20px'} mRight={'5px'} imgUrl={selectedPlayer?.picture} name={selectedPlayer?.name} />
            </>
          ) : (
            <TabSpan>Back to teams</TabSpan>
          )}
        </TabWrapper>
      </FluidContainer>
    </TabContainer>
  );
};
